import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import { Card, CardHeader, CardBody } from '@/components/common/Card';
import Badge from '@/components/common/Badge';
import Button from '@/components/common/Button';
import { getPortalReferrals } from '@/services/affiliateApi';

export default function AffiliatePortalReferrals() {
  const [page, setPage] = useState(1);

  const { data, isLoading } = useQuery({
    queryKey: ['portal-referrals', page],
    queryFn: () => getPortalReferrals(page, 20),
  });

  const referrals = (data as any)?.referrals || [];
  const total = (data as any)?.total || 0;
  const totalPages = Math.ceil(total / 20);

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900">Referrals</h1>
      <Card>
        <CardHeader>
          <p className="text-sm text-gray-500">{total} total referrals</p>
        </CardHeader>
        <CardBody>
          {isLoading ? (
            <div className="text-gray-500 text-center py-8">Loading...</div>
          ) : !referrals.length ? (
            <div className="text-gray-500 text-center py-8">No referrals yet</div>
          ) : (
            <>
              <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                  <tr>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Business</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Billing</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Months Remaining</th>
                    <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {referrals.map((r: any) => (
                    <tr key={r.id}>
                      <td className="px-4 py-3 text-sm">{r.referred_business?.business_name || r.referred_email || 'Pending'}</td>
                      <td className="px-4 py-3 text-sm">
                        <Badge variant={
                          r.status === 'qualified' || r.status === 'commission_active' ? 'success' :
                          r.status === 'churned' ? 'danger' : 'secondary'
                        }>{r.status}</Badge>
                      </td>
                      <td className="px-4 py-3 text-sm">{r.billing_cycle || '—'}</td>
                      <td className="px-4 py-3 text-sm">{r.commission_months_remaining}</td>
                      <td className="px-4 py-3 text-sm text-gray-500">{new Date(r.created_at).toLocaleDateString()}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {totalPages > 1 && (
                <div className="flex items-center justify-between mt-4 px-4">
                  <span className="text-sm text-gray-500">Page {page} of {totalPages}</span>
                  <div className="flex gap-2">
                    <Button size="sm" variant="secondary" disabled={page <= 1} onClick={() => setPage(page - 1)}>Previous</Button>
                    <Button size="sm" variant="secondary" disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Next</Button>
                  </div>
                </div>
              )}
            </>
          )}
        </CardBody>
      </Card>
    </div>
  );
}
